import * as React from 'react';
import { AxiosPromise, AxiosResponse } from 'axios';
import AppDocumentTitle from 'login-components/Common/AppDocumentTitle/AppDocumentTitle';
import AppFooterUpdater from 'login-components/Common/AppFooterUpdater';
import ValidateRequestState from 'login-components/ValidateRequestState/ValidateRequestState';
import { linkToLogin } from 'login-components/Common/Footer/footerConfigs';

interface ActivationProps {
  validateActivation(): AxiosPromise<any>;
  onSuccess?(data: AxiosResponse['data']): void;
}

class Activation extends React.Component<ActivationProps, any> {
  render() {
    const { children, onSuccess, validateActivation } = this.props;
    return (
      <ValidateRequestState onSuccess={onSuccess} validate={validateActivation}>
        <AppDocumentTitle title="Activate">
          <AppFooterUpdater footerConfig={linkToLogin}>{children}</AppFooterUpdater>
        </AppDocumentTitle>
      </ValidateRequestState>
    );
  }
}

export default Activation;
